export const bookingsApiErrorsTranslations = {
  ACTIVE_BOOKINGS_COUNT_REACHED:
    'bookings:createBooking.activeBookingsCountReached',
  BOOKING_CANNOT_BE_CANCELED:
    'bookings:common.cancelBookingDialog.bookingCannotBeCancelled',
  OVERLAPPING_BOOKINGS_FOUND: 'bookings:createBooking.overlappingBookingsFound',
} as const;
